module.exports = __webpack_public_path__ + "static/media/C10.7a68effa.jpg";